import type { JSX } from 'react';
import { Alert, Slide } from '@mui/material';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import { useOnlineStatus } from '@hooks/useOnlineStatus';

export function OfflineBanner(): JSX.Element | null {
  const isOnline = useOnlineStatus();

  if (isOnline) return null;

  return (
    <Slide direction="down" in={!isOnline}>
      <Alert
        icon={<WifiOffIcon fontSize="inherit" />}
        severity="warning"
        variant="filled"
        sx={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: (theme) => theme.zIndex.snackbar + 1, borderRadius: 0, justifyContent: 'center' }}
      >
        You&rsquo;re offline — changes won&rsquo;t save until your connection is restored.
      </Alert>
    </Slide>
  );
}
